import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserRights} from '../../api/types/user.type';

interface ActionMenuDataState {
  userRights: UserRights | null;
}

const initialState: ActionMenuDataState = {
  userRights: null,
};

const actionMenuDataSlice = createSlice({
  name: 'actionMenu',
  initialState,
  reducers: {
    setUserRights: (state, action: PayloadAction<UserRights | null>) => {
      state.userRights = action.payload;
    },

    // clear stored user rights
    clearUserRights: (state) => {
      state.userRights = null;
    },

    addUserRight: (state, action: PayloadAction<any>) => {
      if (!state.userRights) {
        state.userRights = Array.isArray(action.payload)
          ? action.payload
          : ([action.payload] as unknown as UserRights);
      } else if (Array.isArray(state.userRights)) {
        (state.userRights as any[]).push(action.payload);
      } else {
        state.userRights = action.payload as unknown as UserRights;
      }
    },

    removeUserRightsByPredicate: (
      state,
      action: PayloadAction<(r: any) => boolean>
    ) => {
      if (!state.userRights || !Array.isArray(state.userRights)) return;
      state.userRights = (state.userRights as any[]).filter(
        (r) => !action.payload(r)
      ) as unknown as UserRights;
    },
  },
});

export const {
  setUserRights,
  clearUserRights,
  addUserRight,
  removeUserRightsByPredicate,
} = actionMenuDataSlice.actions;

export const selectUserRights = (state: any): UserRights | null =>
  state.actionMenu?.userRights ?? null;

export default actionMenuDataSlice.reducer;
